export default __webpack_public_path__ + "static/media/noBannerAds.fb229d0c.png";